export const PROMOTIONS_LIST_MODES = Object.freeze({
  CREATE: "create",
  REPORT: "report",
});

export const STATUS_PILL_CLASS = {
  CONTACT_PENDING: "promo-pill--pending",
  ADDED_TO_EVENT: "promo-pill--event",
  INVITE_SENT: "promo-pill--sent",
  INVITE_ACCEPTED: "promo-pill--accepted",
  INVITE_REJECTED: "promo-pill--rejected",
  PROMOTION_COMPLETED: "promo-pill--completed",
};

export const SELECT_CHECKBOX_SX = {
  color: "var(--grey400, #98a2b3)",
  "&.Mui-checked": { color: "var(--pblue)" },
  "&.MuiCheckbox-indeterminate": { color: "var(--pblue)" },
  "&.Mui-disabled": { color: "var(--grey300, #d0d5dd)" },
};

export const CREATE_EVENT_VIEW = "createEvent";
